import { useState } from "react";
import { useCreateHallRecordMutation, useGetAdminHallQuery } from "../../features/api/appApi";
import AdminSectionCard, {
  AdminButton,
  AdminEmptyState,
  AdminField,
  AdminFormGrid,
  AdminInput,
  AdminScrollTable,
  AdminTextarea,
} from "./AdminSectionCard";

const defaultHallForm = {
  name: "",
  studentId: "",
  issue: "",
  details: "",
  date: "",
  imageUrl: "",
  proofUrl: "",
};

const AdminHallPage = () => {
  const { data: hallOfShame = [] } = useGetAdminHallQuery();
  const [createHallRecord] = useCreateHallRecordMutation();

  const [hallForm, setHallForm] = useState(defaultHallForm);

  return (
    <AdminSectionCard title="Hall Of Shame" subtitle="Publish verified records">
      <form
        className="space-y-3"
        onSubmit={async (e) => {
          e.preventDefault();
          await createHallRecord(hallForm);
          setHallForm(defaultHallForm);
        }}
      >
        <AdminFormGrid>
          <AdminField label="Name">
            <AdminInput
              placeholder="Name"
              value={hallForm.name}
              onChange={(e) => setHallForm({ ...hallForm, name: e.target.value })}
              required
            />
          </AdminField>

          <AdminField label="Student ID">
            <AdminInput
              placeholder="Student ID"
              value={hallForm.studentId}
              onChange={(e) => setHallForm({ ...hallForm, studentId: e.target.value })}
            />
          </AdminField>

          <AdminField label="Issue">
            <AdminInput
              placeholder="Issue"
              value={hallForm.issue}
              onChange={(e) => setHallForm({ ...hallForm, issue: e.target.value })}
              required
            />
          </AdminField>

          <AdminField label="Date">
            <AdminInput
              type="date"
              value={hallForm.date}
              onChange={(e) => setHallForm({ ...hallForm, date: e.target.value })}
              required
            />
          </AdminField>

          <AdminField label="Image URL" className="md:col-span-2">
            <AdminInput
              placeholder="Image URL"
              value={hallForm.imageUrl}
              onChange={(e) => setHallForm({ ...hallForm, imageUrl: e.target.value })}
            />
          </AdminField>

          <AdminField label="Proof URL" className="md:col-span-2">
            <AdminInput
              placeholder="Proof URL"
              value={hallForm.proofUrl}
              onChange={(e) => setHallForm({ ...hallForm, proofUrl: e.target.value })}
            />
          </AdminField>

          <AdminField label="Details" className="md:col-span-2">
            <AdminTextarea
              placeholder="Details"
              value={hallForm.details}
              onChange={(e) => setHallForm({ ...hallForm, details: e.target.value })}
            />
          </AdminField>
        </AdminFormGrid>

        <AdminButton className="w-full md:w-auto" type="submit">
          Create Record
        </AdminButton>
      </form>

      <div className="mt-5">
        {hallOfShame.length ? (
          <AdminScrollTable>
            <table className="w-full min-w-[860px] text-left text-sm">
              <thead className="bg-slate-50 text-xs uppercase tracking-wide text-slate-500">
                <tr>
                  <th className="px-4 py-3">Name</th>
                  <th className="px-4 py-3">Student ID</th>
                  <th className="px-4 py-3">Issue</th>
                  <th className="px-4 py-3">Date</th>
                  <th className="px-4 py-3">Proof</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100">
                {hallOfShame.map((row) => (
                  <tr key={row.id} className="bg-white hover:bg-slate-50/70">
                    <td className="max-w-[220px] break-words px-4 py-3 font-semibold text-slate-800">
                      {row.name}
                    </td>
                    <td className="px-4 py-3 text-slate-600">{row.studentId || "-"}</td>
                    <td className="max-w-[260px] break-words px-4 py-3 text-slate-600">{row.issue}</td>
                    <td className="px-4 py-3 text-slate-600">
                      {row.date ? new Date(row.date).toLocaleDateString() : "-"}
                    </td>
                    <td className="max-w-[240px] break-words px-4 py-3 text-slate-600">
                      {row.proofUrl || "-"}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </AdminScrollTable>
        ) : (
          <AdminEmptyState text="No hall records published yet." />
        )}
      </div>
    </AdminSectionCard>
  );
};

export default AdminHallPage;
